import Box from '@mui/material/Box';
import { styled, Tooltip, tooltipClasses, TooltipProps } from '@mui/material';

const STATUS_BORDER = '#F79009';

type CameraStatusTooltipProps = TooltipProps & {
  align?: 'start' | 'center';
};

export const CameraStatusTooltip = styled(
  ({ className, align = 'center', placement, ...props }: CameraStatusTooltipProps) => (
    <Tooltip
      {...props}
      placement={placement ?? (align === 'center' ? 'top' : 'top-start')}
      arrow
      classes={{ popper: className }}
      slotProps={{
        popper: {
       //   modifiers: [{ name: 'offset', options: { offset: [0, 5] } }],
          sx: { zIndex: 1600 },
        },
      }}
    />
  ),
)({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#4d4d4d',
    '&::before': {
      border: `1px solid ${STATUS_BORDER}`,
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#4d4d4d',
    border: `1px solid ${STATUS_BORDER}`,
    borderRadius: '6px',

    lineHeight: '16px',
    maxWidth: 280,
    padding: '6px 8px',
    whiteSpace: 'normal',
  },
});

export const CameraDegradedStatusBadge = () => (
  <Box
    component="span"
    aria-hidden
    sx={{
      position: 'absolute',
      top: -5,
      right: -5,
      zIndex: 10,
      width: 14,
      height: 14,
      borderRadius: '50%',
      backgroundColor: STATUS_BORDER,
      color: '#000',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 1,
      pointerEvents: 'none',
    }}
  >
    !
  </Box>
);

export const getDisabledCameraTooltip = (fullName: string, statusMessage?: string) =>
  statusMessage?.trim() ||
  `Unfortunately this ${fullName.toLowerCase()} is unavailable in this game due to a technical issue.`;
